import { IBookingEngineState } from "@app/app/types";

import { getShortId } from "../ids/generateIds";
import { setFilterUrlParams } from "./setFilterUrlParams";

export interface IStateToUrlParamsOptions {
    whitelist?: string[];
}

export const stateToUrlParams = (state: IBookingEngineState, { whitelist }: IStateToUrlParamsOptions = {}): string => {
    const bookingState = state.bookingState || {};
    const params = new URLSearchParams();

    if (!Object.keys(bookingState).length) {
        return params.toString();
    }

    if (state.language) {
        params.set("lg", state.language);
    }

    if (state.currency) {
        params.set("cu", state.currency);
    }

    if (state.promoCode) {
        params.set("pc", state.promoCode);
    } else {
        params.delete("pc");
    }

    if (state.corpCode) {
        params.set("cc", state.corpCode);
    } else {
        params.delete("cc");
    }

    if (state.bookingId) {
        params.set("id", state.bookingId);
    } else {
        params.delete("id");
    }

    if (bookingState.dates?.fromDate && bookingState.dates?.toDate) {
        params.set("d", `${bookingState.dates.fromDate},${bookingState.dates.toDate}`);
    }

    // Collect all booking parameters into an array
    const brParams = (bookingState.bookings || []).map((b) => {
        const packageId = getShortId(b.package?.id || "") || "_";
        const roomId = getShortId(b.room?.id || "") || "_";
        const rateId = getShortId(b.rate?.id || "") || "_";

        const childCountStr = Object.entries(b.childCount)
            .map(([categoryId, count]) => `${categoryId}:${count}`)
            .join(",");

        let br = `${b.id},${packageId},${roomId},${rateId},${b.adultsCount}${!!childCountStr.length ? `,${childCountStr}` : ""}`;

        if (b.extras.length) {
            br = `${br}|${b.extras.map((e) => getShortId(e.id)).join(",")}`;
        }

        return br;
    });

    // Join all bookings with semicolons and set a single 'br' parameter
    if (brParams.length > 0) {
        params.set("br", brParams.join(";"));
    }

    if (whitelist) {
        const entries = Array.from(params.entries());

        entries.forEach(([key, value]) => {
            if (!whitelist.includes(key)) {
                params.delete(key);
            }
        });
    }

    setFilterUrlParams(params, state.bookableItemsFilter);

    return params.toString();
};
